import type { SVGProps } from 'react';

const SvgResilientOracle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.40434 11.7452C1.51517 11.2801 1 10.7277 1 10.1353C1 8.47835 5.02944 7.13525 10 7.13525C14.9706 7.13525 19 8.47835 19 10.1353C19 10.8497 18.2508 11.5058 17 12.0211"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 9.14538L10.01 9.13428"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.8834 4.1353C14.8787 3.11232 14.6206 2.38839 14.0863 2.11614C12.61 1.36394 9.58389 4.34442 7.32733 8.7732C5.07074 13.202 4.43816 17.4021 5.91443 18.1543C6.44186 18.423 7.16711 18.2153 7.98441 17.6353"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.60166 2.38692C6.9413 2.00107 6.35793 1.89017 5.91443 2.11614C4.43816 2.86834 5.07073 7.06837 7.32732 11.4972C9.58394 15.926 12.6099 18.9065 14.0862 18.1543C15.3984 17.4857 15.0445 14.093 13.3648 10.2369"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgResilientOracle;
